import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { PREVIOUS_URL_PATH, REQUESTED_SERVICES_PATH } from "../../../../../constants/env";
import { useDialogHandler } from "../../../../hooks/useDialogHandler";
import { ServiceRequestShowModalOnBackButton } from "../../../../stores/serviceRequestShowModalOnBackButton";
import ConfirmExitFromServiceRequest from "../../../poppers/ConfirmExitFromServiceRequest";
import HeaderV2 from "../../header-v2";
import useHeaderV2Store from "../../hooks/use-header-v2-store.hook";
import type { IHeaderV2LayoutStore } from "../../stores/header-v2-layout-store";
import { HeaderV2LayoutAction } from "../../stores/header-v2-layout-store";

function ProcedurePageHeader(): JSX.Element {
  const { setHeaderV2LayoutStore } = useHeaderV2Store();

  const showModalOnClickToBackButton = useAtomValue(ServiceRequestShowModalOnBackButton);

  const { openDialog } = useDialogHandler({
    dialogComponent: (
      <ConfirmExitFromServiceRequest
        onConfirm={showModalOnClickToBackButton?.action || undefined}
        onCancel={showModalOnClickToBackButton?.actionBack || undefined}
      />
    ),
  });

  useEffect(
    function setInitialStateHeader() {
      const headerOptions: IHeaderV2LayoutStore = {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: REQUESTED_SERVICES_PATH,
          action: showModalOnClickToBackButton.visible ? openDialog : undefined,
        },
        actions: [HeaderV2LayoutAction.chatWithOperator],
      };

      setHeaderV2LayoutStore(headerOptions);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showModalOnClickToBackButton]
  );

  return <HeaderV2 />;
}

export default ProcedurePageHeader;
